import React from 'react';
import { Icon } from './Icon.jsx';

/**
 * v2.0 (A5) — discrepancy status pill.
 *
 * kind ∈ { 'ok' | 'warning' | 'alert' }. Reuses the mint / amber / red
 * palette from the rest of the app. `inGrace` softens the copy when the
 * current month is still inside the 3-working-day grace period (per
 * design Q4) — the pill stays neutral and the label changes.
 */
const STYLE = {
  ok: {
    color: '#026153',
    bg: 'rgba(31,138,91,0.12)',
    icon: 'check',
    label: 'On track',
  },
  warning: {
    color: '#B57651',
    bg: 'rgba(196,124,42,0.14)',
    icon: 'alert',
    label: 'Warning',
  },
  alert: {
    color: '#C4320A',
    bg: 'rgba(196,50,10,0.12)',
    icon: 'alert',
    label: 'Alert',
  },
};

export function StatusPill({ kind, label, size = 'md', inGrace = false }) {
  const s = STYLE[kind] || STYLE.ok;
  const isSm = size === 'sm';
  const displayLabel = label || (inGrace ? 'Grace period' : s.label);
  return (
    <span
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 5,
        padding: isSm ? '2px 8px' : '4px 10px',
        borderRadius: 999,
        background: inGrace ? 'var(--sp-bg-muted)' : s.bg,
        color: inGrace ? 'var(--sp-fg-2)' : s.color,
        fontWeight: 700,
        fontSize: isSm ? 11 : 12,
        lineHeight: 1.4,
      }}
    >
      <Icon
        name={inGrace ? 'clock' : s.icon}
        size={isSm ? 11 : 12}
        stroke={2.4}
      />
      {displayLabel}
    </span>
  );
}
